'use strict';

angular.module('theme').filter('kr', function ($filter) {
	var number = $filter('number');
	return function (amount, fract, nullValue) {
		if (!amount || amount === 0) {
			return nullValue || '--';
		}
		return number(amount, angular.isUndefined(fract) ? 0 : fract) + ' kr';
	};
});
